import checked from '@lernetz/ui-components/src/toggle/defaults/checkboxChecked.html';
import unchecked from '@lernetz/ui-components/src/toggle/defaults/checkboxUnchecked.html';
import template from './checkboxComponent.html';
import {Signal, View} from "@lernetz/ts-lib";
import {observeProperties} from "@lernetz/ts-lib/src/Observer";

export class CheckboxToggle extends View {
    // checkedTemplate: string;
    // uncheckedTemplate: string;
    public constructor() {
        super({ data: { condition: false}});
        // this.checkedTemplate = template;
        // this.uncheckedTemplate = template;
    }

    init() {
        // this.update();
        this.node.innerHTML = template;
        // observeProperties(this.data);
        // this.data.propertyChange.subscribe( event => {
        //     debugger;
        //     this.update();
        // })
    }

    // update(): void {
    //     this.node.innerHTML = this.data.condition ? checked : unchecked;
    // }
}
